module.exports = __webpack_public_path__ + "img/83.2.TN.f9b49d45.png";